import { useMemo } from 'react'
import { FC } from 'react'
import { SegmentButton } from 'components/features/pfm/SegmentButton/SegmentButton'
import LikeIcon from 'icons/like.svg'
import LikedIcon from 'icons/liked.svg'
import { AnalyticsEvent } from 'interfaces/analytics'

type PostLikeButtonProps = {
  counter: number
  pressed: boolean
  hideIcon?: boolean

  onClick?: () => void
}

export const PostLikeButton: FC<PostLikeButtonProps> = (props) => {
  const { hideIcon, counter, pressed, onClick } = props

  let contentChild = (
    <>
      { !hideIcon && (
        <SegmentButton.Icon size={ 14 } src={ LikedIcon } />
      )}
      <SegmentButton.Text text='Liked' />
    </>
  )

  if (!pressed) {
    contentChild = (
      <>
        { !hideIcon && (
          <SegmentButton.Icon size={ 14 } src={ LikeIcon } />
        )}
        <SegmentButton.Text text='Like' />
      </>
    )
  }

  const analyticsAction = useMemo<AnalyticsEvent>(() => ({
    category: 'module-feed_post',
    action: 'toggle-like',
    label: pressed ? 'unlike' : 'like',
  }), [pressed])

  return (
    <SegmentButton
      pressed={ pressed }
      counter={ counter }
      analyticsAction={ analyticsAction }
      onClick={ onClick }
    >
      <SegmentButton.Segment>
        { contentChild }
      </SegmentButton.Segment>
    </SegmentButton>
  )
}
